/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconRewindForward60 = createReactComponent(
  "rewind-forward-60",
  "IconRewindForward60",
  [
    ["path", { d: "M5.007 16.478a6 6 0 0 1 3.993 -10.478h11", key: "svg-0" }],
    [
      "path",
      {
        d: "M15 15.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z",
        key: "svg-1"
      }
    ],
    ["path", { d: "M17 9l3 -3l-3 -3", key: "svg-2" }],
    [
      "path",
      {
        d: "M12 14h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2",
        key: "svg-3"
      }
    ]
  ]
);

export { IconRewindForward60 as default };
//# sourceMappingURL=IconRewindForward60.js.map
